export const addIf = (condition, toAdd) => condition ? [toAdd] : [];